function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Westlands-Stockist-Finder",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stockist-Finder---Landing-Page---Online-Stockists---Desktop",
  transform: "translate(-943.000000, -272.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Online-stockist-panel",
  transform: "translate(485.000000, 272.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(458.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#046A38",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon---Close"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,0 C5.37096774,0 0,5.37096774 0,12 C0,18.6290323 5.37096774,24 12,24 C18.6290323,24 24,18.6290323 24,12 C24,5.37096774 18.6290323,0 12,0 Z M17.883871,15.15 C18.1112903,15.3774194 18.1112903,15.7451613 17.883871,15.9725806 L15.9677419,17.883871 C15.7403226,18.1112903 15.3725806,18.1112903 15.1451613,17.883871 L12,14.7096774 L8.85,17.883871 C8.62258065,18.1112903 8.25483871,18.1112903 8.02741935,17.883871 L6.11612903,15.9677419 C5.88870968,15.7403226 5.88870968,15.3725806 6.11612903,15.1451613 L9.29032258,12 L6.11612903,8.85 C5.88870968,8.62258065 5.88870968,8.25483871 6.11612903,8.02741935 L8.03225806,6.11129032 C8.25967742,5.88387097 8.62741935,5.88387097 8.85483871,6.11129032 L12,9.29032258 L15.15,6.11612903 C15.3774194,5.88870968 15.7451613,5.88870968 15.9725806,6.11612903 L17.8887097,8.03225806 C18.116129,8.25967742 18.116129,8.62741935 17.8887097,8.85483871 L14.7096774,12 L17.883871,15.15 Z",
  id: "Close-circle",
  fill: "#FFFFFF"
}))))));

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.d00c61ad.svg";
export { ForwardRef as ReactComponent };